import Popup from 'reactjs-popup';
import React, { Component } from "react"; 
import 'reactjs-popup/dist/index.css';
import LoadingIndicator from '../components/LoadingIndicator';
import PDFPreviewLink from '../components/PDFPreviewLink';
import Selector from '../components/Selector';
import {getInsurers, getBrokers, createPolicy, updatePolicy} from '../services/BinderDropService';
import {ShrinkNumber} from '../util/Helper'
import FilterSelector from '../components/FilterSelector';

class PolicyDetailsPopup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      policy:{liabilityLimit:0, liabilityStartThreshold:0,premium:0, retention:0, commissionPercentage:0, policyNumber:"", insurer:null},
      insurers:[],
      brokers:[],
    };
  }

  
  componentDidUpdate(prevProps) {
    if (prevProps && prevProps.loading && !this.props.loading) {
      this.setInitialPolicyState();
    }
  }


  onOpen = () => {
    this.setInitialPolicyState();
    
    getInsurers().then((insurers) => {
      this.setState({insurers});
    });
  }

  setInitialPolicyState = () =>{

    var policy = {
      liabilityLimit:this.props.policy.liabilityLimit || 0, 
      liabilityStartThreshold:this.props.policy.liabilityStartThreshold || this.props.tower?.totalLimit || 0,
      premium:this.props.policy.premium || 0, 
      retention:this.props.policy.retention || 0, 
      commissionPercentage:this.props.policy.commissionPercentage || 0, 
      policyNumber:this.props.policy.policyNumber || 0, 
      insurer:this.props.policy.insurer || null, 
      type:this.props.policy?.type,
      policyId:this.props.policy?.policyId || null,
    };

    var hasLeadA = false;
    if(this.props.tower){
      this.props.tower.policies.forEach(p => {
        if(p.type.indexOf("Lead Side A") > -1)  hasLeadA = true;
      });
    }

    if(hasLeadA){
      if(!policy.type || policy.type === "Lead Side A"){
        policy.type = 'Excess A';
      }
    }
    else{
      if(!policy.type){
        policy.type = 'Excess A/B/C';
      }
      if(policy.type === 'Excess A'){ //If no lead side A yet, no excess A
        policy.type = "Lead Side A";
      }
    }
    
    this.setState({saving:false, policy})
  }

  onCloseClick = () =>{
    this.props.onClose(false);
  }

  onSaveClick = () => {
    this.setState({saving:true});
    if(this.state.policy.liabilityStartThreshold){
      this.state.policy.retention = 0;
    }
    else{
      this.state.policy.type = "Primary"
    }

    
    if(this.state.policy.policyId){
      updatePolicy(this.state.policy).then((resp) => {
        if(resp?.policyId){
          this.props.onClose(true);
        }
        else{//TODO show error
          this.setState({saving:false});
        }
      });
    }
    else{

        createPolicy(this.state.policy, this.props.towerID).then((resp) => {
          if(resp?.policyId){
            this.props.onClose(true);
          }
          else{//TODO show error
            this.setState({saving:false});
          }
        });   
      
    }
  };


  render() {
    

    return (
        <Popup className='policyDetailsPopup popupInputFields' onOpen={this.onOpen} closeOnDocumentClick={false} open={this.props.open} position="center center">
                    
                    <label>{this.props.update ? "Update": "Add"} Policy Details</label>
                    <div className='popupSplit'>
                      <div className='popupSplitHalf card'>
                      {this.props.pdf && this.props.pdf.src &&
                        <PDFPreviewLink pdf={this.props.pdf}/>
                      }
                      
                      </div>
                      <div className='popupSplitHalf'>
                      {this.props.loading &&
                          <LoadingIndicator text="Processing PDF(s)..."/>
                      }
                        {!this.props.loading &&
                        <div className="popupContentInner">
                            <span>Insurer</span>
                            
                            <FilterSelector searchPlaceholderText="Type to find insurer" placeholderText="Select insurer" defaultValue={this.state.policy.insurer}  options={this.state.insurers} onChange={(e) => this.setState({ policy: { ...this.state.policy, insurer: e} })}/>
                            <span>Limit</span>
                            <div  className="fieldInputOutter">
                              <input type="text" placeholder="" className="fieldInput" value={ this.state.policy.liabilityLimit } onChange={(e) => {console.log(e.target.value); if(!isNaN(e.target.value)) this.setState({ policy: { ...this.state.policy, liabilityLimit: e.target.value*1} })}}/>
                              <div className="fieldInputPreview">${this.state.policy.liabilityLimit > -1 ? ShrinkNumber(this.state.policy.liabilityLimit) : ""}</div>
                              
                            </div>

                            <span>Attachment Point</span>
                            <div  className="fieldInputOutter">
                              <input type="text" placeholder="" className="fieldInput" value={ this.state.policy.liabilityStartThreshold } onChange={(e) => {if(!isNaN(e.target.value)) this.setState({ policy: { ...this.state.policy, liabilityStartThreshold: e.target.value*1} })}}/>
                              <div className="fieldInputPreview">${this.state.policy.liabilityStartThreshold > -1 ? ShrinkNumber(this.state.policy.liabilityStartThreshold) : ""}</div>
                            </div>

                            <div className='popHorizontal'>
                              <span>Premium</span>
                              <span>Comission %</span>
                            </div>

                            <div className='popHorizontal'>
                              <div  className="fieldInputOutter">
                                <input type="text" placeholder="" className="fieldInput" value={ this.state.policy.premium } onChange={(e) => {if(!isNaN(e.target.value)) this.setState({ policy: { ...this.state.policy, premium: e.target.value*1} })}}/>
                                <div className="fieldInputPreview">${this.state.policy.premium > -1 ? ShrinkNumber(this.state.policy.premium) : ""}</div>
                              </div>
                              <div  className="fieldInputOutter">
                              <input type="text" placeholder="" className="fieldInput" value={ this.state.policy.commissionPercentage } onChange={(e) => {if(!isNaN(e.target.value) && e.target.value*1 < 30) this.setState({ policy: { ...this.state.policy, commissionPercentage: e.target.value*1} })}}/>
                              <div className="fieldInputPreview">{this.state.policy.commissionPercentage > -1 ? this.state.policy.commissionPercentage : ""}%</div>
                              </div>
                            </div>

                            

                            
                            

                            <div className='popHorizontal'>
                              <span>{this.state.policy.liabilityStartThreshold ?  "Type" : "Retention"}</span>
                              <span>Policy Number</span>
                            </div>
                            <div className='popHorizontal'>
                              {this.state.policy.liabilityStartThreshold > 0 &&
                              <Selector onChange={(value) => {this.setState({ policy: { ...this.state.policy, type: value} })}} defaultValue={this.state.policy.type} options={['Excess A/B/C', 'Lead Side A', 'Excess A', ]}/>
                              }
                              {!this.state.policy.liabilityStartThreshold &&
                              <div  className="fieldInputOutter">
                                <input type="text" placeholder="" className="fieldInput" value={ this.state.policy.retention } onChange={(e) => {if(!isNaN(e.target.value)) this.setState({ policy: { ...this.state.policy, retention: e.target.value*1} })}}/>
                                <div className="fieldInputPreview">${this.state.policy.retention > -1 ? ShrinkNumber(this.state.policy.retention) : ""}</div>
                              </div>
                              }
                              <div  className="fieldInputOutter">
                                <input type="text" placeholder="" className="fieldInput" value={ this.state.policy.policyNumber } onChange={(e) => {this.setState({ policy: { ...this.state.policy, policyNumber: e.target.value} })}}/>
                              </div>
                            </div>
                            
                            
                            
                            
                            
                          
                            <button tabIndex={1} className='pillButton' disabled={!this.state.policy.insurer || !this.state.policy.liabilityLimit || !this.state.policy.premium}  onClick={this.onSaveClick}>Save Policy</button>
                            <a  onClick={this.onCloseClick}>Or Cancel</a>
                        </div>
                        }
                        {this.state.saving &&
                        <div className="popupOverlay">
                          <span>{this.props.update ? 'Updating Policy...' :'Creating Policy...'}</span>
                        </div>
                        }
                      </div>
                    </div>
        </Popup>
    );
  }
}
 
export default PolicyDetailsPopup;